(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-card-wrapper').forEach(function(wrapper) {
    var link = wrapper.querySelector('.card-collection__cover-link');
    if (!link) return;
    wrapper.style.cursor = 'pointer';
    wrapper.addEventListener('click', function(e) {
      var clicked = e.target.closest('a[href]');
      if (clicked && clicked !== link) return;
      window.location.href = link.getAttribute('href');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Card swatches v2 — DEDUPE + IN-PLACE COLOUR SWAP (15 Jul).
     One card per style: sibling colourways are hidden and their
     image / title link / price are captured first; tapping a swatch
     swaps that data into the visible card instead of navigating.
     Grouping runs PER GRID (ul.product-grid) — the same style can
     appear in two sections (Shop Victorious + Best Sellers) and must
     dedupe within each, never across.
     NOTE (17 Jul): the best-sellers dedupe-off experiment was
     REVERTED once the carousel headings got a visible "View all"
     link — both carousels dedupe colourways again; the View-all
     covers anyone wanting the full 16-product list. */
  var COLOR_HEX = {
    black: '#1a1a1a', white: '#f0f0f0', grey: '#8c8c8c', gray: '#8c8c8c',
    mint: '#6dc5a8', blue: '#4a7ebd', green: '#3d7a4a', navy: '#1a2a5c',
    red: '#c0392b', pink: '#e89eb0', purple: '#6b3fa0', yellow: '#f0c430',
    orange: '#e67e22', brown: '#7d4e2d', cream: '#e8dcc8', beige: '#e8dcc8',
    stone: '#c2b08a', khaki: '#c4b46a', olive: '#6b7c3e',
    'light blue': '#8bbdd9', 'dark blue': '#1a2a6c',
    'light grey': '#c8c8c8', 'light gray': '#c8c8c8', 'dark green': '#1e4d2b'
  };

  var MULTI = Object.keys(COLOR_HEX)
    .filter(function (k) { return k.indexOf(' ') !== -1; })
    .sort(function (a, b) { return b.length - a.length; });

  function extractColor(title) {
    var lower = title.toLowerCase();
    for (var i = 0; i < MULTI.length; i++) {
      if (lower.indexOf(MULTI[i] + ' ') === 0) {
        return { color: MULTI[i], baseName: title.slice(MULTI[i].length + 1) };
      }
    }
    var sp = title.indexOf(' ');
    if (sp < 0) return { color: null, baseName: title };
    var primary = title.slice(0, sp).split('/')[0].toLowerCase();
    if (Object.prototype.hasOwnProperty.call(COLOR_HEX, primary)) {
      return { color: primary, baseName: title.slice(sp + 1) };
    }
    return { color: null, baseName: title };
  }

  function getCardData(product) {
    var img = product.wrapper.querySelector('.card__media .media img');
    var price = product.wrapper.querySelector('.card-information .price');
    return {
      url: product.url,
      title: product.title,
      imgSrc: img ? img.getAttribute('src') : null,
      imgSrcset: img ? img.getAttribute('srcset') : null,
      imgAlt: img ? img.getAttribute('alt') : null,
      priceHTML: price ? price.innerHTML : null
    };
  }

  function applyCardData(wrapper, data) {
    var img = wrapper.querySelector('.card__media .media img');
    if (img && data.imgSrc) {
      img.setAttribute('src', data.imgSrc);
      if (data.imgSrcset) img.setAttribute('srcset', data.imgSrcset);
      if (data.imgAlt !== null) img.setAttribute('alt', data.imgAlt);
    }
    wrapper.querySelectorAll('.card__heading a').forEach(function (a) {
      a.setAttribute('href', data.url);
    });
    var price = wrapper.querySelector('.card-information .price');
    if (price && data.priceHTML) price.innerHTML = data.priceHTML;
  }

  function buildGrid(grid) {
    var wrappers = grid.querySelectorAll('.product-card-wrapper');
    if (!wrappers.length) return;

    var products = [];
    for (var i = 0; i < wrappers.length; i++) {
      var anchor = wrappers[i].querySelector('.card__heading a');
      if (!anchor) continue;
      var parsed = extractColor(anchor.textContent.trim());
      products.push({ wrapper: wrappers[i], title: anchor.textContent.trim(), url: anchor.getAttribute('href'), color: parsed.color, baseName: parsed.baseName });
    }

    var groups = {};
    for (var j = 0; j < products.length; j++) {
      if (!products[j].color) continue;
      var key = products[j].baseName.toLowerCase().trim();
      if (!groups[key]) groups[key] = [];
      groups[key].push(products[j]);
    }

    Object.keys(groups).forEach(function (key) {
      var group = groups[key];
      var keeper = group[0];
      var infoEl = keeper.wrapper.querySelector('.card-information');
      if (!infoEl || infoEl.querySelector('.card-swatches')) return;

      /* Capture every colourway's data BEFORE hiding its card */
      var datas = group.map(getCardData);

      /* Dedupe: hide sibling cards — their data lives on in `datas` */
      for (var h = 1; h < group.length; h++) {
        var li = group[h].wrapper.closest('.grid__item');
        if (li) li.style.display = 'none';
        else group[h].wrapper.style.display = 'none';
      }

      /* Deduped card shows the base style name, no colour prefix */
      if (group.length > 1) {
        keeper.wrapper.querySelectorAll('.card__heading a').forEach(function (a) {
          a.textContent = keeper.baseName;
        });
      }

      var row = document.createElement('div');
      row.className = 'card-swatches';
      row.setAttribute('aria-label', 'Available colours');

      group.forEach(function (sib, idx) {
        var a = document.createElement('a');
        a.href = sib.url;
        a.className = 'card-swatch' + (idx === 0 ? ' card-swatch--active' : '');
        a.setAttribute('title', sib.title);
        var dot = document.createElement('span');
        dot.className = 'card-swatch__dot';
        if (COLOR_HEX[sib.color]) dot.style.backgroundColor = COLOR_HEX[sib.color];
        a.appendChild(dot);

        if (group.length > 1) {
          /* In-place swap instead of navigation; the card's own link
             now points at whichever colourway is selected */
          a.addEventListener('click', function (e) {
            e.preventDefault();
            applyCardData(keeper.wrapper, datas[idx]);
            row.querySelectorAll('.card-swatch--active').forEach(function (el) {
              el.classList.remove('card-swatch--active');
            });
            a.classList.add('card-swatch--active');
          });
        }

        row.appendChild(a);
      });

      infoEl.appendChild(row);
    });
  }

  function buildSwatches() {
    document.querySelectorAll('ul.product-grid').forEach(buildGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildSwatches);
  } else {
    buildSwatches();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(function () {
  var COLOR_HEX = {
    black: '#1a1a1a', white: '#f0f0f0', grey: '#8c8c8c', gray: '#8c8c8c',
    mint: '#6dc5a8', blue: '#4a7ebd', green: '#3d7a4a', navy: '#1a2a5c',
    red: '#c0392b', pink: '#e89eb0', purple: '#6b3fa0', yellow: '#f0c430',
    orange: '#e67e22', brown: '#7d4e2d', cream: '#e8dcc8', beige: '#e8dcc8',
    stone: '#c2b08a', khaki: '#c4b46a', olive: '#6b7c3e',
    'light blue': '#8bbdd9', 'dark blue': '#1a2a6c',
    'light grey': '#c8c8c8', 'light gray': '#c8c8c8', 'dark green': '#1e4d2b'
  };

  var MULTI = Object.keys(COLOR_HEX)
    .filter(function (k) { return k.indexOf(' ') !== -1; })
    .sort(function (a, b) { return b.length - a.length; });

  function extractColor(title) {
    var lower = title.toLowerCase();
    for (var i = 0; i < MULTI.length; i++) {
      if (lower.indexOf(MULTI[i] + ' ') === 0) {
        return { color: MULTI[i], baseName: title.slice(MULTI[i].length + 1) };
      }
    }
    var sp = title.indexOf(' ');
    if (sp < 0) return { color: null, baseName: title };
    var primary = title.slice(0, sp).split('/')[0].toLowerCase();
    if (Object.prototype.hasOwnProperty.call(COLOR_HEX, primary)) {
      return { color: primary, baseName: title.slice(sp + 1) };
    }
    return { color: null, baseName: title };
  }

  function buildSwatches() {
    var wrappers = document.querySelectorAll('.product-card-wrapper');
    if (!wrappers.length) return;

    var products = [];
    for (var i = 0; i < wrappers.length; i++) {
      var anchor = wrappers[i].querySelector('.card__heading a');
      if (!anchor) continue;
      var parsed = extractColor(anchor.textContent.trim());
      products.push({ wrapper: wrappers[i], title: anchor.textContent.trim(), url: anchor.getAttribute('href'), color: parsed.color, baseName: parsed.baseName });
    }

    var groups = {};
    for (var j = 0; j < products.length; j++) {
      if (!products[j].color) continue;
      var key = products[j].baseName.toLowerCase().trim();
      if (!groups[key]) groups[key] = [];
      groups[key].push(products[j]);
    }

    var keys = Object.keys(groups);
    for (var k = 0; k < keys.length; k++) {
      var group = groups[keys[k]];
      for (var m = 0; m < group.length; m++) {
        var current = group[m];
        var infoEl = current.wrapper.querySelector('.card-information');
        if (!infoEl || infoEl.querySelector('.card-swatches')) continue;
        var row = document.createElement('div');
        row.className = 'card-swatches';
        row.setAttribute('aria-label', 'Available colours');
        for (var n = 0; n < group.length; n++) {
          var sib = group[n];
          var a = document.createElement('a');
          a.href = sib.url;
          a.className = 'card-swatch' + (sib === current ? ' card-swatch--active' : '');
          a.setAttribute('title', sib.title);
          var dot = document.createElement('span');
          dot.className = 'card-swatch__dot';
          if (COLOR_HEX[sib.color]) dot.style.backgroundColor = COLOR_HEX[sib.color];
          a.appendChild(dot);
          row.appendChild(a);
        }
        infoEl.appendChild(row);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildSwatches);
  } else {
    buildSwatches();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var COLOR_HEX = {
    black: '#1a1a1a', white: '#f0f0f0', grey: '#8c8c8c', gray: '#8c8c8c',
    mint: '#6dc5a8', blue: '#4a7ebd', green: '#3d7a4a', navy: '#1a2a5c',
    red: '#c0392b', pink: '#e89eb0', purple: '#6b3fa0', yellow: '#f0c430',
    orange: '#e67e22', brown: '#7d4e2d', cream: '#e8dcc8', beige: '#e8dcc8',
    stone: '#c2b08a', khaki: '#c4b46a', olive: '#6b7c3e',
    'light blue': '#8bbdd9', 'dark blue': '#1a2a6c',
    'light grey': '#c8c8c8', 'light gray': '#c8c8c8', 'dark green': '#1e4d2b'
  };

  var MULTI = Object.keys(COLOR_HEX)
    .filter(function (k) { return k.indexOf(' ') !== -1; })
    .sort(function (a, b) { return b.length - a.length; });

  function extractColor(title) {
    var lower = title.toLowerCase();
    for (var i = 0; i < MULTI.length; i++) {
      if (lower.indexOf(MULTI[i] + ' ') === 0) {
        return { color: MULTI[i], baseName: title.slice(MULTI[i].length + 1) };
      }
    }
    var sp = title.indexOf(' ');
    if (sp < 0) return { color: null, baseName: title };
    var primary = title.slice(0, sp).split('/')[0].toLowerCase();
    if (Object.prototype.hasOwnProperty.call(COLOR_HEX, primary)) {
      return { color: primary, baseName: title.slice(sp + 1) };
    }
    return { color: null, baseName: title };
  }

  function buildProductSwatches() {
    var mount = document.querySelector('.product-page-swatches-mount');
    if (!mount) return;

    var titleEl = document.querySelector('.product__title h1');
    if (!titleEl) return;

    var title = titleEl.textContent.trim();
    var parsed = extractColor(title);
    if (!parsed.color) return;

    var baseName = parsed.baseName.toLowerCase().trim();

    var seen = {};
    var siblings = (window.__swatchCandidates || []).filter(function (p) {
      if (seen[p.url]) return false;
      seen[p.url] = true;
      var sp = extractColor(p.title);
      return sp.color && sp.baseName.toLowerCase().trim() === baseName;
    });

    var row = document.createElement('div');
    row.className = 'card-swatches product-page-swatches';

    var cur = document.createElement('a');
    cur.href = window.location.pathname;
    cur.className = 'card-swatch card-swatch--active';
    cur.setAttribute('title', title);
    var curDot = document.createElement('span');
    curDot.className = 'card-swatch__dot';
    if (COLOR_HEX[parsed.color]) curDot.style.backgroundColor = COLOR_HEX[parsed.color];
    cur.appendChild(curDot);
    row.appendChild(cur);

    siblings.forEach(function (sib) {
      var sp = extractColor(sib.title);
      var a = document.createElement('a');
      a.href = sib.url;
      a.className = 'card-swatch';
      a.setAttribute('title', sib.title);
      var dot = document.createElement('span');
      dot.className = 'card-swatch__dot';
      if (sp.color && COLOR_HEX[sp.color]) dot.style.backgroundColor = COLOR_HEX[sp.color];
      a.appendChild(dot);
      row.appendChild(a);
    });

    mount.parentNode.insertBefore(row, mount);
    mount.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildProductSwatches);
  } else {
    buildProductSwatches();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsive-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Measure the sticky strip above the hero (code bar + header) into
     --vctrs-header-offset so the hero's 100svh calc lands the CTA
     exactly at the bottom of the first visible screen. */
  function measure() {
    var total = 0;
    var bar = document.querySelector('.code-bar-section');
    var head = document.querySelector('.section-header');
    if (bar) total += bar.offsetHeight;
    if (head) total += head.offsetHeight;
    if (total > 0) {
      document.documentElement.style.setProperty('--vctrs-header-offset', total + 'px');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measure);
  } else {
    measure();
  }
  window.addEventListener('resize', measure);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(measure);
    var bar = document.querySelector('.code-bar-section');
    var head = document.querySelector('.section-header');
    if (bar) ro.observe(bar);
    if (head) ro.observe(head);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
